<template>
  <div id="tabCohorts">
    <div class="margin-subpages">
      <div>
        <div class="flex-row-center">
          <div class="flex-center-1 fs-24 f-000000">
            <span class="fw-900">{{
              cohortsAll.length > 0
                ? $utils("addCommasInNumber", cohortsAll.length)
                : 0
            }}</span>
            <span class="fw-600">&nbsp;{{ $t("members.Cohorts") }}</span>
            <span
              v-if="cohortsDuplicate.status"
              class="tag-pill tag-pill--md tag-pill--cased tag-pill--danger duplicate-pill"
              >{{ cohortsDuplicate.count }}
              {{ $t("members.duplicate_cohorts") }}</span
            >
          </div>
          <el-button
            @click="addTeam"
            class="btn-primary-purple"
            size="small"
            icon="el-icon-plus"
            >{{ $t("members.ADD_COHORT") }}</el-button
          >
        </div>
        <div class="flex-row-between mt-24">
          <el-input
            class="input-style"
            style="font-size: 14px; height: 40px"
            autosize
            :placeholder="$t('members.Search')"
            v-model="inputSearch"
            clearable
          ></el-input>
          <div style="width: 220px">
            <el-menu class="input-select" mode="horizontal">
              <el-submenu index="0" style="width: 220px">
                <template slot="title">
                  <span class="text-dropdown" id="sortby">{{
                    $t("members.Sort_by_Name")
                  }}</span>
                </template>
                <el-menu-item
                  index="1"
                  @click="sortBy('name')"
                  style="font-size: 14px; width: 220px"
                  >{{ $t("members.Sort_by_Name") }}</el-menu-item
                >
              </el-submenu>
            </el-menu>
          </div>
        </div>
        <div class="mt-24">
          <div class="center py-40 my-40" v-if="loadingCohortsTable">
            <div
              v-for="item in [1, 2, 3, 4, 5]"
              :key="'mock_team_' + item"
              :class="{
                'opa-01': item == 5,
                'opa-02': item == 4,
                'opa-04': item == 3,
                'opa-06': item == 2,
              }"
              class="grid-4"
            >
              <div
                class="team-sitebar"
                style="background: #747474; opacity: 0.4"
              ></div>
              <div class="px-24 flex-center">
                <div class="flex-column">
                  <div
                    class="fw-700 fs-17 text-skeleton mt-4"
                    style="width: 120px"
                  >
                    &nbsp;
                  </div>
                </div>
              </div>
              <div class="px-24 flex-center">
                <div class="flex-column">
                  <div
                    class="fw-700 fs-10 text-skeleton opa-04"
                    style="width: 50px"
                  >
                    &nbsp;
                  </div>
                  <div class="flex-row-center mt-4">
                    <div class="opa-04" style="display: flex">
                      <div
                        v-for="index in [1, 2, 3, 4]"
                        :key="index + '_mock_user'"
                      >
                        <div v-if="index < 7">
                          <div>
                            <div
                              class="image-skeleton image-profile-32"
                              :style="renderMemberPic(index)"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-24 flex-center ml-auto">
                <div class="flex-column">
                  <div
                    class="fw-700 fs-14 text-skeleton mt-4"
                    style="width: 120px"
                  >
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="item in cohorts"
            :key="item.key"
            :class="{ duplicateStyle: item.duplicate }"
            class="grid-4"
            @click="editCohort(item)"
          >
            <div
              class="team-sitebar"
              v-bind:style="cohortBarStyleFunc(item.color)"
            ></div>
            <div class="px-24 flex-center">
              <div>
                <div class="fw-700 fs-17 fc-000000 ellipsis"
                :class="[ blurMode ?  'blurelement': '' ]">{{
                  item.name
                }}</div>
                <div class="fw-500 fs-13 fc-000000 opa-06 pt-2"
                :class="[ blurMode ?  'blurelement': '' ]"
                 style="max-width: 400px">
                  {{
                    item.description ? item.description : item.company_name
                  }}
                </div>
            </div>
            </div>
            <div class="px-24 flex-center">
              <div class="flex-column">
                <span class="fc-4A4A4A fs-12"
                  >{{ item.sup ? item.sup.length : 0 }}
                  {{ $t("members.Members") }}</span
                >
                <div class="flex-row-center mt-2">
                  <div v-if="item.sup" style="display: flex">
                    <div v-for="(member, index) in item.sup" :key="index">
                      <div v-if="index < 7">
                        <div v-if="member.pic">
                          <img
                            v-lazy="member.pic"
                            :key="member.pic"
                            class="image-skeleton image-profile-32"
                            :class="[ blurMode ?  'blurelement': '' ]"
                            v-bind:style="renderMemberPic(index)"
                          />
                        </div>
                        <div
                          v-else
                          class="image image-profile-32"
                          :class="[
                            $utils('avatarTone', { firstName: member.firstname, lastName: member.lastname }),
                            blurMode ? 'blurelement' : ''
                          ]"
                          v-bind:style="renderMemberPic(index)"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: member.firstname,
                                lastName: member.lastname,
                              })
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="item.sup && item.sup.length > 7"
                      class="image image-profile-32"
                      style="margin-left: -74px; z-index: 100"
                    >
                      <div
                        :class="`text-in-image flex-mid opa-08 fs-${
                          item.sup.length > 100 ? '10' : '12'
                        }`"
                        style="font-weight: 700"
                      >
                        {{
                          item.sup && item.sup.length > 7
                            ? "+" + (item.sup.length - 7)
                            : ""
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="px-24 flex-center">
              <div class="flex-center fw-700 ml-auto fc-4A4A4A fs-14">
                <span v-if="item.type && item.type == 'auto'" class="opa-05">{{
                  $t("members.Auto_generated")
                }}</span>
                <span v-else>{{ "Custom" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-20 pagination flex-center" v-if="!loadingCohortsTable">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next"
          :total="results.length"
        ></el-pagination>
        <span class="results-status">
          {{ cohorts.length > 10 ? 10 : cohorts.length }}
          {{ $t("members.results_from") }}
          {{ $utils("addCommasInNumber", results.length) }}
          {{ $t("members.results") }}
        </span>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogFormVisible"
      top="8vh"
      :before-close="handleFormDialogClose"
      custom-class="cohort-dialog ch-modal"
    >
      <div
        class="sidebar-modal-color"
        v-bind:class="renderSidebarColorFunc(modalForm.color)"
      ></div>
      <el-form :model="modalForm" ref="modalForm">
        <el-col
          :span="modalForm.cohort_kind === 'dynamic' ? 10 : 11"
          class="first-column profileform"
          :class="{ 'first-column-collapsed': modalForm.cohort_kind === 'dynamic' }"
        >
          <div class="first-column-content"
            :style="modalForm.cohort_kind === 'dynamic'
              ? 'padding: 36px 32px;'
              : 'padding: 40px 36px;'"
          >
            <el-col :span="24">
              <p class="txtHeaderStyle">{{ $t("members.Cohort_Type") }}</p>
              <el-radio-group
                v-model="modalForm.cohort_kind"
                :disabled="modalForm.mode === 'edit' && modalForm.type === 'auto'"
                @change="onCohortKindChange"
                class="cohort-type-radio"
              >
                <el-radio label="manual">{{ $t("members.Manual") }}</el-radio>
                <el-radio label="dynamic">{{ $t("members.Dynamic") }}</el-radio>
              </el-radio-group>
            </el-col>
            <el-col :span="24" style="padding-top: 20px">
              <p class="txtHeaderStyle">{{ $t("members.Cohort_Name") }}</p>
              <el-input
                class="cohort-field"
                auto-complete="off"
                :placeholder="$t('members.Cohort_Name')"
                v-model="modalForm.cohort_name"
                :disabled="modalForm.type == 'auto'"
                :class="[ blurMode ?  'blurelement': '' ]"
              ></el-input>
            </el-col>
            <el-col
              v-if="modalForm.cohort_kind === 'manual'"
              :span="24"
              style="padding-top: 24px"
            >
              <p class="txtHeaderStyle">{{ $t("members.Add_members_to_this") }}</p>
              <div>
                <el-autocomplete
                  popper-class="my-autocomplete"
                  class="cohort-field"
                  v-model="state"
                  :fetch-suggestions="querySearchAsync"
                  :placeholder="$t('members.Select_Member')"
                  style="width: 100%"
                  @select="handleSelect"
                  :disabled="!refreshInput || modalForm.type == 'auto'"
                  :class="[ blurMode ?  'blurelement': '' ]"
                >
                  <template slot-scope="{ item }">
                    <div v-if="item.toType && item.toType == 'user'"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="value">
                        {{ item.firstname }} {{ item.lastname }}
                      </div>
                      <div class="email">{{ item.email }}</div>
                    </div>
                    <div v-else class="value"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ item.label }}</div>
                  </template>
                </el-autocomplete>
              </div>
              <div class="opa-05 fc-000000 fs-14 right mt-12">
                {{ $t("members.Bulk_add_by_inputing") }}
              </div>
            </el-col>
            <el-col
              :span="24"
              :style="modalForm.cohort_kind === 'dynamic' ? 'padding-top: 16px' : 'padding-top: 24px'"
            >
              <p class="txtHeaderStyle">{{ $t("members.Cohort_Leader") }}</p>
              <div>
                <el-cascader
                  class="defaulttags input-recipient"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  ref="refTo"
                  :disabled="!refreshInput"
                  v-model="modalForm.leaders"
                  :placeholder="$t('members.Select_Leaders')"
                  :options="optionMember"
                  :props="propsCofig"
                  :collapse-tags="modalForm.leaders.length > 18"
                  @change="changeDataLeader"
                  :filter-method="filterToFunction"
                  :debounce="500"
                  filterable
                >
                  <template slot-scope="{ node, data }">
                    <span v-if="data.toType == 'user'"
                    :class="[ blurMode ?  'blurelement': '' ]"
                      >{{ data.firstname }} {{ data.lastname }}</span
                    >
                    <span v-else
                    :class="[ blurMode ?  'blurelement': '' ]">{{ data.label }}</span>
                  </template>
                </el-cascader>
              </div>
              <div class="opa-05 fc-000000 fs-14 right mt-12">
                {{ $t("members.Leader_description") }}
              </div>
            </el-col>
            <el-col
              :span="24"
              :style="modalForm.cohort_kind === 'dynamic'
                ? 'padding-top: 24px'
                : 'padding-top: 40px'"
            >
              <p class="txtHeaderStyle">{{ $t("members.Color_Tag") }}</p>
              <div
                :style="modalForm.cohort_kind === 'dynamic'
                  ? 'display: flex; flex-direction: row; align-items: center; flex-wrap: wrap; gap: 8px;'
                  : 'display: flex; flex-direction: row; align-items: center; position: absolute;'"
              >
                <div
                  v-for="(color, index) in tagColorMaster"
                  :key="index"
                  class="tagColor"
                  @click="tagColorCheckFunc(index, color)"
                  v-bind:class="[
                    {
                      'active-check':
                        modalForm.selectedColorForUpdate === index,
                    },
                    `bg-${color}`,
                  ]"
                ></div>
              </div>
            </el-col>
            <el-col
              :span="24"
              :style="modalForm.cohort_kind === 'dynamic'
                ? 'padding-top: 32px; display: grid; grid-template-columns: 1fr 1fr; gap: 8px; align-items: center;'
                : 'padding-top: 40px; display: flex; align-items: center'"
            >
              <el-button class="btnAddTeamModal" @click="saveCohort">{{
                modalForm.mode
                  ? $t("members.SAVE_CHANGES")
                  : $t("members.CREATE")
              }}</el-button>
              <el-button
                v-if="modalForm.mode"
                :disabled="modalForm.sup.length > 0 || modalForm.type == 'auto'"
                class="btnCancelTeamModal btn-gray"
                type="primary"
                @click="deleteCohort"
                >{{ $t("members.DELETE") }}</el-button
              >
              <el-button
                v-else
                class="btnCancelTeamModal btn-gray"
                type="primary"
                @click="dialogFormVisible = false"
                >{{ $t("members.CANCEL") }}</el-button
              >
            </el-col> 
            <el-col 
              :span="24" 
              :style="modalForm.cohort_kind === 'dynamic' 
                ? 'padding-top: 32px; margin-top: auto;' 
                : 'padding-top: 32px'"
            >
              <div class="flex-center">
                <p class="txtHeaderStyle">Internal Value</p>
                <el-tooltip placement="top">
                  <div slot="content">
                    <div class="flex-mid ml-auto fs-11" style="width: 210px;">
                      This unique identifier will be used when syncing with
                      integration partners. Once created it can't be edited.
                    </div>
                  </div>
                  <img
                    :src="$utils('icons', 'ic_help_outline-16px')"
                    alt="icons_ic_help_outline-16px"
                    class="ml-12 pb-8"
                    />
                </el-tooltip>
              </div>
              <div
                @click="copyURL(modalForm.internal_id)"
                class="style-internal-value flex-center"
              >
                {{ modalForm.internal_id }}
              </div>
            </el-col>
          </div>
        </el-col>
        <el-col
          :span="modalForm.cohort_kind === 'dynamic' ? 14 : 13"
          class="second-column"
          :class="{ 'second-column-expanded': modalForm.cohort_kind === 'dynamic' }"
        >
          <!-- Dynamic Cohort Builder -->
          <div v-if="modalForm.cohort_kind === 'dynamic'" class="dynamic-cohort-container">
            <div class="dynamic-builder-section" v-if="showDynamicBuilder">
              <dynamic-cohort-builder
                ref="dynamicCohortBuilder"
                v-model="modalForm.rules"
                :blur-mode="blurMode"
                :modal-form="modalForm"
                @preview-updated="onPreviewUpdated"
                @preview-loading="onPreviewLoading"
              ></dynamic-cohort-builder>
            </div>
            <div class="dynamic-preview-section" :style="!showDynamicBuilder ? 'min-height: 0;' : ''">
              <dynamic-cohort-preview
                :preview="modalForm.preview"
                :loading="previewLoading"
                :blur-mode="blurMode"
              ></dynamic-cohort-preview>
            </div>
          </div>

          <!-- Manual Member Table -->
          <template v-else>
            <div
              v-if="modalForm.sup.length == 0"
              class="px-40 manual-empty"
              style="padding-top: 36px"
            >
              <span class="fc-000000 fs-20 fw-900"
                >{{ modalForm.sup ? modalForm.sup.length : 0 }}
                {{ $t("members.members") }}</span
              >
              <div class="flex-mid manual-empty-body mt-40">
                <div>
                  <div class="center mb-20">
                    <img src="../../assets/images/cohorts/add_user.png" />
                  </div>
                  <div class="fc-000000 opa-02 fw-900 fs-20">
                    {{ $t("members.Add_members_to_this") }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="pl-40 pr-20" style="padding-top: 36px">
            <span class="fc-000000 fs-20 fw-900"
              >{{ modalForm.sup ? modalForm.sup.length : 0 }}
              {{ $t("members.members") }}</span
            >
            <div style="">
              <el-table
                :data="modalForm.sup"
                style="width: 100%"
                empty-text="No Cohort members"
                max-height="760px"
                class="el-table-thin-scrollbar"
              >
                <el-table-column width="58">
                  <template slot-scope="scope">
                    <div class="divMember">
                      <div v-if="scope.row.pic">
                        <img
                          v-lazy="scope.row.pic"
                          :key="scope.row.pic"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                          class="image-skeleton image-profile-42"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                      </div>
                      <div v-else class="image image-profile-42"
                      :class="[
                        $utils('avatarTone', { firstName: scope.row.firstname, lastName: scope.row.lastname }),
                        blurMode ? 'blurelement' : ''
                      ]">
                        <div class="text-in-image text-in-image-42 flex-mid">
                          {{
                            $utils("acronymName", {
                              firstName: scope.row.firstname,
                              lastName: scope.row.lastname,
                            })
                          }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('members.Members')" min-width="200">
                  <template slot-scope="scope">
                    <div style="display: flex; flex-direction: column">
                      <span class="text-name"
                      :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ scope.row.firstname }}
                        {{ scope.row.lastname }}</span
                      >
                      <span class="text-email"
                      :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('members.Team')" min-width="160">
                  <template slot-scope="scope">
                    <span class="fc4A4A4A fs-14 ellipsis"
                    :class="[ blurMode ?  'blurelement': '' ]">{{
                      scope.row.team_name
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('members.Status')"
                  align="center"
                  width="90"
                >
                  <template slot-scope="scope">
                    <div class="div-active">
                      <div
                        class="btn-status"
                        :class="[`status-${scope.row.status}`]"
                      >
                        {{ scope.row.status }}
                      </div>
                      <div class="active">{{ scope.row.to_now }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  width="30"
                  v-if="modalForm.type !== 'auto'"
                >
                  <template slot-scope="scope">
                    <div
                      @click.prevent="removeMemberFromCohort(scope.row)"
                      class="fc-000000 opa-03 cursor-pointer"
                      style="display: inline-flex; align-items: center;"
                    >
                      <happily-icon name="trash" :size="18" />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          </template>
        </el-col>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { link } from "fs";
import DynamicCohortBuilder from "./cohorts/DynamicCohortBuilder.vue";
import DynamicCohortPreview from "./cohorts/DynamicCohortPreview.vue";

export default {
  name: "cohorts",
  components: {
    loadingEven: require("../even/loading").default,
    DynamicCohortBuilder,
    DynamicCohortPreview,
  },
  async created() {
    await this.$store.dispatch('main/getuser', this.updateMember === true);
    await Promise.all([
      this.$store.dispatch("membersCohort/getCohorts", this.user),
      this.$store.dispatch("powerups/getOptionTo", this.user),
      this.$store.dispatch("powerups/getOptionLeader", this.user),
    ]);
    this.$store.commit("authen/setActiveIndex", "3");
    this.rootAddTeamHandler = () => this.addTeam();
    this.$root.$on('addTeam', this.rootAddTeamHandler);
  },
  beforeDestroy() {
    if (this.rootAddTeamHandler) {
      this.$root.$off('addTeam', this.rootAddTeamHandler);
    }
  },
  computed: {
    inputSearch: {
      get() {
        return this.$store.getters["membersCohort/inputSearch"];
      },
      set(value) {
        this.$store.commit("membersCohort/setinputSearch", { value });
      },
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    updateMember() {
      return this.$store.getters["newmember/updateMember"];
    },
    cohorts() {
      return this.$store.getters["membersCohort/cohorts"];
    },
    cohortsAll() {
      return this.$store.getters["membersCohort/cohortsall"];
    },
    membersall() {
      return this.$store.getters["membersCohort/membersall"];
    },
    membersallForLeader() {
      return this.$store.getters["powerups/membersall"];
    },
    membersByTeam() {
      return this.$store.getters["membersCohort/membersByTeam"];
    },
    membersByCohort() {
      return this.$store.getters["membersCohort/membersByCohort"];
    },
    membersByHouse() {
      return this.$store.getters["membersCohort/membersByHouse"];
    },
    page() {
      return this.$store.getters["membersCohort/page"];
    },
    results() {
      return this.$store.getters["membersCohort/results"];
    },
    cohortsDuplicate() {
      return this.$store.getters["membersCohort/cohortsDuplicate"];
    },
    loadingCohortsTable() {
      return this.$store.getters["membersCohort/loadingCohortsTable"];
    },
    selectMember() {
      return this.$store.getters["powerups/optionToForCohort"];
    },
    cohortRandomNumber() {
      return this.$store.getters["membersCohort/cohortRandomNumber"];
    },
    optionMember() {
      return this.$store.getters["powerups/optionMember"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    showDynamicBuilder() {
      return (
        this.modalForm.cohort_kind === "dynamic" &&
        !!this.modalForm.rules
      );
    },
  },
  watch: {
    inputSearch() {
      this.$store.dispatch("membersCohort/searchCohorts", this.inputSearch);
    },
    cohortRandomNumber(){
      if(this.cohortRandomNumber){
        this.modalForm.internal_id = this.cohortRandomNumber
        this.$nextTick(() => this.captureFormSnapshot());
      }
    }
  },
  data() {
    return {
      formLabelWidth: "140px",
      dialogFormVisible: false,
      activeIndex: "1",
      id: "",
      mode: "",
      team: "",
      team_name: "",
      current_page: 1,
      modalForm: {
        id: "",
        mode: "",
        newMember: [],
        cohort_name: "",
        sup: [],
        color: "#6C30CC",
        selectedColorForUpdate: 0,
        type: "",
        newMemberAdd: {},
        internal_id: "",
        leaders: [],
        leaderMember: [],
        cohort_kind: "manual", // 'manual' or 'dynamic'
        rules: null, // RuleGroupJSON for dynamic cohorts
        preview: {
          count: 0,
          members: [],
        },
      },
      modalFormSnapshot: null,
      previewLoading: false,
      tagColorMaster: [
        "6C30CC",
        "4F86C6",
        "50B0C6",
        "379392",
        "68D5B5",
        "EE7885",
        "C99EC4",
        "84B1ED",
        "31AADE",
        "F0DC05",
        "E63A40",
      ],
      refreshInput: true,
      placeholderFixed: true,
      state: "",
      timeout: null,
      propsCofig: { multiple: true, value: 'value_options_cohorts' },
      // backups to preserve manual members when toggling cohort_kind
      manualSupBackup: [],
      manualNewMemberAddBackup: {},
    };
  },
  methods: {
    copyURL(value) {
      const clipboardData = window.clipboardData || navigator.clipboard;

      try {
        clipboardData.writeText(value);
        // Show a success message
        this.$message({
          message: `Copy ID to clipboard.`,
          type: "success",
        });
      } catch (error) {
        // Handle any errors
        console.error("Error copying ID to clipboard:", error);

        // Show an error message
        this.$message({
          message: `Failed to copy ID to clipboard.`,
          type: "error",
        });
      }
    },
    saveCohort() {
      if (!this.modalForm.cohort_name.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Valid Cohort Name required.",
          type: "error",
        });
        return false;
      }
      
      // Validate dynamic cohort has rules only when builder is shown (custom dynamic)
      if (this.modalForm.cohort_kind === "dynamic") {
        if (this.showDynamicBuilder && (!this.hasValidRules(this.modalForm.rules))) {
          this.$message({
            showClose: true,
            message: "Please add at least one valid rule for dynamic cohort.",
            type: "error",
          });
          return false;
        }
        // Set type to 'auto' for dynamic cohorts
        this.modalForm.type = "auto";
      } else {
        // Manual cohorts: ensure type is not 'auto' unless editing existing auto cohort
        if (this.modalForm.mode !== "edit") {
          this.modalForm.type = "";
        }
      }

      if (this.modalForm.mode == "edit") {
        this.$store.dispatch("membersCohort/updateCohort", this.modalForm);
      } else {
        this.$store.dispatch("membersCohort/createCohorts", this.modalForm);
      }
      setTimeout(() => {
        this.update_success();
      }, 1000);
    },
    hasValidRules(group) {
      if (!group || !group.children || group.children.length === 0) {
        return false;
      }
      return group.children.some((child) => {
        if (child.op) {
          return this.hasValidRules(child);
        } else {
          return child.field && child.operator && this.hasValidRuleValue(child);
        }
      });
    },
    hasValidRuleValue(rule) {
      if (rule.operator === "BETWEEN") {
        return Array.isArray(rule.value) && rule.value[0] != null && rule.value[1] != null;
      } else if (["IN", "NOT_IN"].includes(rule.operator)) {
        return Array.isArray(rule.value) && rule.value.length > 0;
      } else {
        return rule.value != null && rule.value !== "";
      }
    },
    onCohortKindChange() {
      if (this.modalForm.cohort_kind === "dynamic") {
        // Initialize rules if not set
        if (!this.modalForm.rules) {
          this.modalForm.rules = {
            id: "root",
            op: "AND",
            children: [
              {
                id: `rule_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                field: "",
                operator: "",
                value: undefined,
              },
            ],
          };
        }
        // Preserve manual members while switching to dynamic
        // so that switching back to manual restores them.
        this.manualSupBackup = Array.isArray(this.modalForm.sup) ? [...this.modalForm.sup] : [];
        this.manualNewMemberAddBackup = { ...(this.modalForm.newMemberAdd || {}) };
        // Do not mutate sup when switching to dynamic; manual table is hidden anyway.
        // If needed to avoid accidental edits, we could clear view-only derived state, but keep data intact.
      } else {
        // Clear dynamic rules
        this.modalForm.rules = null;
        // Restore manual members if we previously backed them up
        if (this.manualSupBackup && this.manualSupBackup.length > 0) {
          this.modalForm.sup = [...this.manualSupBackup];
        }
        if (this.manualNewMemberAddBackup && Object.keys(this.manualNewMemberAddBackup).length > 0) {
          this.modalForm.newMemberAdd = { ...this.manualNewMemberAddBackup };
        }
        this.modalForm.preview = { count: 0, members: [] };
      }
    },
    onPreviewUpdated(preview) {
      this.modalForm.preview = preview;
    },
    onPreviewLoading(loading) {
      this.previewLoading = loading;
    },
    addTeam() {
      this.cancelAdd();
      this.$store.dispatch("membersCohort/generateCohortRandomNumber");
      this.dialogFormVisible = true;
    },
    editCohort(item) {
      this.modalForm.mode = "edit";
      this.modalForm.id = item.key;
      this.modalForm.cohort_name = item.name;
      this.modalForm.sup = item.sup || [];
      // Reset backups to the current manual state when opening the dialog
      this.manualSupBackup = Array.isArray(this.modalForm.sup) ? [...this.modalForm.sup] : [];
      this.manualNewMemberAddBackup = {};
      this.modalForm.color = item.color;
      this.modalForm.newMember = [];
      this.modalForm.newMemberAdd = {};
      this.modalForm.type = item.type ? item.type : "";
      
      // Set cohort_kind based on type
      if (item.type === "auto") {
        this.modalForm.cohort_kind = "dynamic";
        // If rules exist, treat as custom dynamic and load them; otherwise, it's a preset - hide builder
        if (item.rules) {
          this.modalForm.rules = item.rules;
          this.modalForm.preview = { count: 0, members: [] };
        } else {
          this.modalForm.rules = null; // preset dynamic → no builder
          // Show the actual cohort members on the right
          const members = this.modalForm.sup || [];
          this.modalForm.preview = { count: members.length, members };
        }
      } else {
        this.modalForm.cohort_kind = "manual";
        this.modalForm.rules = null;
        this.modalForm.preview = { count: 0, members: [] };
      }
      
      this.modalForm.leaders = [];
      this.modalForm.leaderMember = [];
      let leaders = [];
      let leaderMember = [];
      if(item.leaders && Object.keys(item.leaders).length > 0){
        for(const keys in item.leaders){
          leaders.push(["user_" + item.leaders[keys]]);
          leaderMember.push(this.membersall[item.leaders[keys]])
        }
        this.modalForm.leaders = leaders;
        this.modalForm.leaderMember = leaderMember;
      }
      let colorCode = null;
      if (item.color) {
        colorCode = item.color.replace(/#/g, "");
      }
      this.modalForm.selectedColorForUpdate =
        this.tagColorMaster.indexOf(colorCode);
      this.modalForm.internal_id = item.internal_id;

      this.dialogFormVisible = true;

      if(item.type === "auto" && !_.isEmpty(item.rules)) {
        this.$nextTick(() => {
          const builderRef = this.$refs.dynamicCohortBuilder;
          if (builderRef && typeof builderRef.initializeMembers === "function") {
            builderRef.initializeMembers();
          }
        });
      }
      this.$nextTick(() => this.captureFormSnapshot());
    },
    cancelAdd() {
      this.modalForm.mode = "";
      this.modalForm.id = "";
      this.modalForm.cohort_name = "";
      this.modalForm.sup = [];
      this.manualSupBackup = [];
      this.manualNewMemberAddBackup = {};
      this.modalForm.newMember = [];
      this.modalForm.newMemberAdd = {};
      this.modalForm.type = "";
      this.modalForm.color = "#6C30CC";
      this.modalForm.selectedColorForUpdate = 0;
      this.modalForm.internal_id = "";
      this.modalForm.leaders = [];
      this.modalForm.leaderMember = [];
      this.modalForm.cohort_kind = "manual";
      this.modalForm.rules = null;
      this.modalForm.preview = { count: 0, members: [] };
      this.modalFormSnapshot = null;
      this.previewLoading = false;
      this.dialogFormVisible = false;
    },
    captureFormSnapshot() {
      this.modalFormSnapshot = _.cloneDeep(this.modalForm);
    },
    isFormDirty() {
      if (!this.modalFormSnapshot) return false;
      return !_.isEqual(this.modalForm, this.modalFormSnapshot);
    },
    handleFormDialogClose(done) {
      if (!this.isFormDirty()) {
        done();
        return;
      }
      this.$confirm(
        "You have unsaved changes. Discard them?",
        "Unsaved changes",
        {
          confirmButtonText: "Discard",
          cancelButtonText: "Keep editing",
          type: "warning",
        }
      )
        .then(() => done())
        .catch(() => {});
    },
    update_success() {
      let message = "Cohort successfully created";
      if (this.modalForm.mode == "edit") {
        message = "Cohort Information Updated";
      }
      this.cancelAdd();
      this.$message({
        type: "success",
        message,
      });
      // Add new data to local storge
    },
    deleteCohort() {
      this.$confirm(
        `Are you sure you want to delete <strong>${this.modalForm.cohort_name}</strong>?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("membersCohort/deleteCohort", this.modalForm.id);
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "Cohort deleted",
          });
        })
        .then(() => {
          // remove data from local storge
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.$store.dispatch("membersCohort/currentChange", val);
    },
    sortBy(type) {
      if (type == "name") {
        document.getElementById("sortby").innerHTML = "Sort by Name";
      }
      // else if (type == "parent") {
      //   document.getElementById("sortby").innerHTML = "Sort by Parent";
      // }
      this.$store.dispatch("membersCohort/sortBy", type);
    },
    // tableRowStyle({ row, rowIndex }) {
    //   if (row.duplicate) {
    //     return "background: #FEEAE9;";
    //   }
    // },
    cohortBarStyleFunc(color) {
      if (color) {
        return "background: " + color;
      } else {
        return "background:#747474;";
      }
    },
    tagColorCheckFunc(index, color) {
      this.modalForm.selectedColorForUpdate = index;
      this.modalForm.color = "#" + color;
    },
    renderSidebarColorFunc(code) {
      if (code) {
        let color = code.replace(/#/g, "");
        return `bg-${color}`;
      } else {
        return "bg-747474";
      }
    },
    renderMemberPic(index) {
      if (index == 0) {
        return "";
      } else {
        return `left: ${index * -10}px; position: relative`;
      }
    },
    changeDataLeader(arrTag) {
      let _data = [];
      for (const i in arrTag) {
        if (arrTag[i][0].indexOf("user_") !== -1) {
          let userId = arrTag[i][0].replace(/user_/g, "");
          const userTeam = _.filter(this.membersallForLeader, { email: userId });
          if (userTeam.length > 0) {
            let chkUser = _.filter(_data, { email: userTeam[0].email });
            if (chkUser.length == 0) {
              _data.push(userTeam[0]);
            }
          }
        }
      }
      const result = _.sortBy(_data, [
        function (o) {
          return o.firstname;
        },
      ]);
      this.modalForm.leaderMember = result;

    },
    changeDataTo() {
      this.modalForm.newMember = [...new Set(this.modalForm.newMember)];
      console.log("TODO: changeDataTo", this.modalForm.newMember); // TODO: let this data showing in table!
      const member = {};
      if(this.modalForm.newMember.length > 0){
        _.forEach(this.modalForm.newMember, (item, key) => {
          if (item.indexOf("user_") !== -1) {
            let email = item.replace(/user_/g, "");
            let keyId = email.replace(/\./g, "||");
            if (member[keyId] == undefined) {
              member[keyId] = new Object();
            }
            member[keyId] = email;
            if (Object.keys(member).length > 0) {
              for (const x in member) {
                let checkExist = _.filter(this.modalForm.sup, {
                  email: member[x],
                });
                if (this.membersall[member[x]] && checkExist.length == 0) {
                  this.modalForm.sup = _.concat(
                    this.modalForm.sup,
                    this.membersall[member[x]]
                  );
                }
              }
            }
            this.modalForm.newMemberAdd = {
                ...this.modalForm.newMemberAdd,
                ...member,
              };
          }
        });
      }
      this.state = "";
    },
    removeMemberFromCohort(data) {
      this.$confirm(
        `Are you sure you want to remove <strong>${data.firstname} ${data.lastname}</strong>?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          if (this.modalForm.newMemberAdd[data.key]) {
            delete this.modalForm.newMemberAdd[data.key];
          } else {
            this.$store.dispatch("membersCohort/removeUserCohort", {
              id: this.modalForm.id,
              userKey: data.key,
            });
          }

          const index = this.modalForm.sup.findIndex(
            (obj) => obj.key === data.key
          );
          this.modalForm.sup.splice(index, 1);
          this.$message({
            type: "success",
            message: "Member removed",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    getCohortUsersMap(cohortId) {
      return this.membersByCohort[cohortId] || {};
    },
    resolveMemberRecord(email, selectedItem) {
      if (this.membersall[email]) {
        return this.membersall[email];
      }
      if (
        selectedItem &&
        selectedItem.toType === "user" &&
        selectedItem.email === email
      ) {
        return selectedItem;
      }
      return null;
    },
    querySearchAsync(queryString, cb) {
      let options = this.selectMember;
      let results = queryString
        ? options.filter(this.createFilter(queryString))
        : options;
      cb(results);
    },
    createFilter(queryString) {
      let results = (link) => {
        this.filterToFunctionOnInput(link, queryString);
        let value =
          link.label.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
        if (!value && link.toType == "user") {
          value =
            link.email.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
        }
        return value;
      };
      return results;
    },
    handleSelect(item) {
      if (!item || !item.value_options_cohorts) {
        this.state = "";
        return;
      }
      const member = {};
      const cohortUsers =
        this.modalForm.mode == "edit" && this.modalForm.id
          ? this.getCohortUsersMap(this.modalForm.id)
          : null;
      if (this.modalForm.mode == "edit" && this.modalForm.id) {
          if (item.value_options_cohorts == "all_members") {
            for (const x in this.membersall) {
              if (cohortUsers[this.membersall[x].key] == undefined) {
                if (member[this.membersall[x].key] == undefined) {
                  member[this.membersall[x].key] = new Object();
                }
                member[this.membersall[x].key] = this.membersall[x].email;
              }
            }
          } else if (item.value_options_cohorts.indexOf("team_") !== -1) {
            let teamId = item.value_options_cohorts.replace(/team_/g, "");
            if (this.membersByTeam[teamId]) {
              for (const x in this.membersByTeam[teamId]) {
                if (
                  cohortUsers[this.membersByTeam[teamId][x].key] == undefined
                ) {
                  if (member[this.membersByTeam[teamId][x].key] == undefined) {
                    member[this.membersByTeam[teamId][x].key] = new Object();
                  }
                  member[this.membersByTeam[teamId][x].key] =
                    this.membersByTeam[teamId][x].email;
                }
              }
            }
          } else if (item.value_options_cohorts.indexOf("user_") !== -1) {
            let email = item.value_options_cohorts.replace(/user_/g, "");
            let keyId = email.replace(/\./g, "||");
            if (cohortUsers[keyId] == undefined) {
              if (member[keyId] == undefined) {
                member[keyId] = new Object();
              }
              member[keyId] = email;
            }
          } else if (item.value_options_cohorts.indexOf("house_") !== -1) {
            let houseId = item.value_options_cohorts.replace(/house_/g, "");
            if (this.membersByHouse[houseId]) {
              _.forEach(this.membersByHouse[houseId], (houseMember) => {
                let keyId = houseMember.email.replace(/\./g, "||");
                if (cohortUsers[keyId] == undefined) {
                  if (member[keyId] == undefined) {
                    member[keyId] = new Object();
                  }
                  member[keyId] = houseMember.email;
                }
              });
            }
          }
          if (Object.keys(member).length > 0) {
            for (const x in member) {
              let checkExist = _.filter(this.modalForm.sup, {
                email: member[x],
              });
              const userRecord = this.resolveMemberRecord(member[x], item);
              if (userRecord && checkExist.length == 0) {
                this.modalForm.sup = _.concat(
                  this.modalForm.sup,
                  userRecord
                );
              }
            }
          }
        } else {
          if (item.value_options_cohorts == "all_members") {
            for (const x in this.membersall) {
              if (member[this.membersall[x].key] == undefined) {
                member[this.membersall[x].key] = new Object();
              }
              member[this.membersall[x].key] = this.membersall[x].email;
            }
          } else if (item.value_options_cohorts.indexOf("team_") !== -1) {
            let teamId = item.value_options_cohorts.replace(/team_/g, "");
            if (this.membersByTeam[teamId]) {
              for (const x in this.membersByTeam[teamId]) {
                if (member[this.membersByTeam[teamId][x].key] == undefined) {
                  member[this.membersByTeam[teamId][x].key] = new Object();
                }
                member[this.membersByTeam[teamId][x].key] =
                  this.membersByTeam[teamId][x].email;
              }
            }
          } else if (item.value_options_cohorts.indexOf("user_") !== -1) {
            let email = item.value_options_cohorts.replace(/user_/g, "");
            let keyId = email.replace(/\./g, "||");
            if (member[keyId] == undefined) {
              member[keyId] = new Object();
            }
            member[keyId] = email;
          } else if (item.value_options_cohorts.indexOf("house_") !== -1) {
            let houseId = item.value_options_cohorts.replace(/house_/g, "");
            if (this.membersByHouse[houseId]) {
              _.forEach(this.membersByHouse[houseId], (item, key) => {
                let keyId = item.email.replace(/\./g, "||");
                if (member[keyId] == undefined) {
                  member[keyId] = new Object();
                }
                member[keyId] = item.email;
              });
            }
          }
          if (Object.keys(member).length > 0) {
            for (const x in member) {
              let checkExist = _.filter(this.modalForm.sup, {
                email: member[x],
              });
              const userRecord = this.resolveMemberRecord(member[x], item);
              if (userRecord && checkExist.length == 0) {
                this.modalForm.sup = _.concat(
                  this.modalForm.sup,
                  userRecord
                );
              }
            }
          }
        }
      this.modalForm.newMemberAdd = {
        ...this.modalForm.newMemberAdd,
        ...member,
      };
      this.modalForm.newMember.push(item.value_options_cohorts);
      this.state = "";
    },
    filterToFunctionOnInput(node, keyword) {
      this.placeholderFixed = false;
      let space = keyword.split(" ");
      let comma = keyword.split(",");
      let commaAndSpace = keyword.split(", ");
      let keywordArr = comma;
      if (space.length > comma.length) {
        keywordArr = space;
      } else if (
        commaAndSpace.length > comma.length ||
        commaAndSpace.length > space.length
      ) {
        keywordArr = commaAndSpace;
      }
      if (keywordArr.length > 1 && node.email) {
        for (let i = 0; i < keywordArr.length; i++) {
          if (node.toType == "user") {
            if (keywordArr[i].trim() == node.email) {
              this.modalForm.newMember = this.modalForm.newMember.concat([
                "user_" + node.email,
              ]);
              this.changeDataTo(this.modalForm.newMember);
            }
          }
        }
      }
    },
    filterToFunction(node, keyword) {
      const keywordArr = keyword.split(/, | /);
      if (keywordArr.length > 1) {
        for (let i = 0; i < keywordArr.length; i++) {
          const keywordTrim = keywordArr[i].trim();
          if (node.data.toType == "user") {
            if (
              node.data.firstname
                .toLowerCase()
                .indexOf(keywordTrim.toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (
              node.data.lastname
                .toLowerCase()
                .indexOf(keywordTrim.toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (keywordTrim === node.data.email) {
              this.modalForm.leaders.push(["user_" + node.data.email]);
              this.refreshInput = false;
              setTimeout(() => {
                this.refreshInput = true;
              }, i * 75);
            }
          }
        }
        setTimeout(() => {
          this.$refs.refTo.inputValue = "";
          this.$refs.refTo.dropDownVisible = false;
        }, keywordArr.length * 75);
        this.$refs.refTo.handleClear();
      } else {
        if (node.data.toType == "user") {
          if (
            node.data.firstname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (
            node.data.lastname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (keyword === node.data.email) {
            this.modalForm.leaders.push(["user_" + node.data.email]);
            this.refreshInput = false;
            this.changeDataLeader(this.modalForm.leaders);
            setTimeout(() => {
              this.refreshInput = true;
            }, 100);
            this.$refs.refTo.inputValue = "";
            this.$refs.refTo.dropDownVisible = false;
            this.$refs.refTo.handleClear();
          }
        } else {
          return (
            node
              .getText(false, null)
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-4 {
  display: grid;
  grid-template-columns: 7px 50% 27% 23%;
  margin-top: 10px;
  height: 79px;
  border: 1px solid #e2e4ea;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: border-color .15s ease, box-shadow .15s ease, transform .15s ease;
}
.grid-4:hover {
  border-color: rgba(108, 48, 204, 0.28);
  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);
  transform: translateY(-1px);
}
.duplicate-pill {
  margin-left: 14px;
  cursor: pointer;
}
/* Primary purple action — list-page Add buttons */
.btn-primary-purple.el-button {
  background-color: #6c30cc;
  border-color: #6c30cc;
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.02em;
  transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;
}
.btn-primary-purple.el-button:hover,
.btn-primary-purple.el-button:focus {
  background-color: #5a25b0;
  border-color: #5a25b0;
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(108, 48, 204, 0.18);
}
.divContent {
  background: #ffffff;
}
.el-submenu {
  width: 220px;
}
.txtSubOption {
  font-size: 14px;
  width: 220px;
}
.txtOption {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  display: inline-block;
}
.el-dropdown-menu__item {
  font-size: 14px;
  font-weight: 500;
  color: #585858;
}
li.el-dropdown-menu__item:hover {
  background-color: #6c30cc;
  color: #ffffff;
}
div.el-dropdown {
  padding-left: 0px;
}
.image-profile-32 {
  border: 1px solid #ffffff;
}
.duplicateStyle {
  background: #fff4f4;
  border-color: rgba(204, 48, 48, 0.28);
}
.team-sitebar {
  border-radius: 0;
  opacity: 1;
  height: 100%;
}
.first-column {
  background-color: #f8f8f8;
  // height: 100%;
  min-height: 0;
  border-radius: 3px 0 0 3px;
  
  // Ensure the inner wrapper truly fills and behaves as a flex column
  .first-column-content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    
    // ElementUI grid uses floats; disable them so flex layout works
    > .el-col {
      float: none;
      display: block; // keep normal block flow
      // Allow margin-top: auto on later sections to work reliably
      flex: 0 0 auto;
    }
  }
  
  &.first-column-collapsed {
    // Optimized spacing for dynamic cohorts
    // Make the collapsed column itself a flex container so its content can stretch
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    min-height: 0;
    
    // Ensure the inner wrapper fills remaining height in dynamic mode
    .first-column-content {
      flex: 1 1 auto !important;
      height: auto !important;
      min-height: 0;
    }
    
    // Scrollbar styling
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: #e8e8e8;
    }
    &::-webkit-scrollbar-thumb {
      background: #c0c0c0;
      border-radius: 3px;
      
      &:hover {
        background: #a0a0a0;
      }
    }
    
    .txtHeaderStyle {
      font-size: 13px;
      padding-bottom: 6px;
      margin-bottom: 0;
    }
    
    .cohort-field {
      .el-input__inner {
        height: 38px;
        font-size: 14px;
      }
    }
    
    .cohort-type-radio {
      .el-radio {
        margin-right: 16px;
        
        .el-radio__label {
          font-size: 13px;
        }
      }
    }
    
    .defaulttags.input-recipient {
      .el-input__inner {
        height: 38px;
        font-size: 14px;
      }
    }
    
    .tagColor {
      width: 32px;
      height: 32px;
      margin-right: 0;
    }
    
    .btnAddTeamModal {
      width: 100%;
      height: 40px;
      font-size: 13px;
    }
    
    .btnCancelTeamModal {
      width: 100%;
      height: 40px;
      font-size: 13px;
    }
    
    .style-internal-value {
      height: 38px;
      font-size: 14px;
      padding: 0 16px;
      cursor: pointer;
      transition: all 0.2s ease;
      
      &:hover {
        background-color: #d4d4d4;
      }
    }
    
    .opa-05 {
      font-size: 12px;
    }
  }
}
.second-column {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  &.second-column-expanded {
    overflow: hidden;
  }
  
  .dynamic-cohort-container {
    padding: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: 12px;
    
    .dynamic-builder-section {
      flex: 0 0 auto;
      max-height: 50%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    
    .dynamic-preview-section {
      flex: 1;
      min-height: 180px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }

  // Manual empty-state layout improvements (no fixed heights)
  .manual-empty {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .manual-empty-body {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.txtHeaderStyle {
  margin: 0px;
  padding-bottom: 10px;
  font-size: 11px;
  font-weight: 700;
  color: #8a8a8a;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.tagColor {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 8px;
  border: 2px solid transparent;
  box-shadow: 0 1px 2px rgba(17, 24, 39, 0.08);
  transition: transform .15s ease, box-shadow .15s ease;
}
.tagColor:hover {
  transform: scale(1.08);
  box-shadow: 0 4px 12px rgba(17, 24, 39, 0.12);
}
.tagColor.active-check {
  border-color: #ffffff;
  box-shadow: 0 0 0 2px #6c30cc, 0 4px 12px rgba(108, 48, 204, 0.18);
}
.bg- {
  background: #747474;
}
.active-check {
  background-image: url("../../assets/images/outline-check-18px@2x.png");
  background-repeat: no-repeat;
  background-size: 30px 30px;
}
.btnAddTeamModal {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  width: 176px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnAddTeamModal:hover {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.6;
}
.btnCancelTeamModal {
  min-width: 122px;
  height: 50px;
  padding: 0 16px;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 700;
}
.guideTextModal {
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  opacity: 0.65;
  word-break: normal;
}
.sidebar-modal-color {
  content: "";
  position: absolute;
  border-radius: 2px 0 0 2px;
  height: 100%;
  top: 0;
  left: 0;
  width: 14px;
}
.btn-cancel-color {
  background-color: #747474;
}
.style-internal-value {
  height: 44px;
  background-color: #f6f7f9;
  border: 1px solid #e2e4ea;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #4a4a4a;
  padding: 0 18px;
  cursor: pointer;
  transition: background-color .15s ease, border-color .15s ease;
}
.style-internal-value:hover {
  background-color: #eef0f5;
  border-color: #d4d7de;
  color: #2f2f2f;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .value {
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 16px;
      color: #000;
      padding: 2px 16px 0;
    }
    .email {
      font-size: 12px;
      padding: 0 16px 0;
      color: #747474;
    }
  }
}
</style>
<style lang="scss">
#tabCohorts {
  // Constrain dialog to viewport and allow its body to fill available height
  .cohort-dialog {
    .el-dialog {
      display: flex;
      flex-direction: column;
      height: 86vh;
      max-height: 86vh;
      min-height: 0;
    }
    .el-dialog__header {
      flex: 0 0 auto;
    }
    .el-dialog__body {
      flex: 1 1 auto;
      overflow: hidden;
      padding: 0;
      display: flex;
      min-height: 0;
    }
    .el-dialog__body .el-form {
      // height: 100%;
      display: flex;
      align-items: stretch;
      width: 100%;
      min-height: 0;
    }
    // Convert Element columns to flex children so both sides stretch full height
    .el-dialog__body .el-form > .el-col {
      float: none;
      display: flex;
      flex-direction: column;
      // height: 100%;
      min-height: 0;
    }
  }

  // Dynamic cohort builder specific styles
  .dynamic-cohort-container {
    .el-select,
    .el-input-number,
    .el-autocomplete {
      .el-input__inner {
        border-radius: 4px;
        transition: all 0.2s ease;
        
        &:focus {
          border-color: #32c2d5;
          box-shadow: 0 0 0 2px rgba(50, 194, 213, 0.1);
        }
      }
    }
    
    .el-input-number {
      background-color: transparent;
      
      .el-input__inner {
        padding-left: 40px;
        padding-right: 40px;
        background-color: #fff;
      }
      
      .el-input-number__decrease,
      .el-input-number__increase {
        background-color: transparent;
      }
    }
    
    .el-select-dropdown__item.selected {
      color: #32c2d5;
      font-weight: 600;
    }
  }
  
  .el-cascader__tags .el-tag:not(.is-hit) {
    border-color: #6c30cc;
    background-color: #6c30cc24;
    color: #6c30cc;
    font-size: 15px;
    height: 30px;
    .el-tag .el-icon-close {
      background-color: #6c30cc;
      color: #6c30cc;
    }
  }
  .el-cascader__tags .el-tag .el-icon-close {
    background-color: #6c30cc;
    margin-top: 2px;
  }
  .el-cascader .el-input.is-focus .el-input__inner {
    border-color: #6c30cc;
  }
  .el-input__inner {
    height: 46px;
    &:focus {
      border-color: #6c30cc;
    }
  }
  .el-cascader .el-cascader__search-input {
    font-size: 16px;
  }
  .input-recipient {
    width: 100%;
  }
  .el-submenu__title {
    border-radius: 4px 0 0 4px;
    height: 40px;
    line-height: 40px;
    background-color: #f4f4f4;
  }
  
  // .defaulttags {
  //   .el-cascader__tags .el-tag {
  //     background: #eae1f8;
  //   }
  //   .el-cascader__tags .el-tag:not(.is-hit) {
  //     border-color: #6c30cc;
  //   }
  //   .el-cascader__tags .el-tag.is-hit {
  //     border-width: 2px;
  //     border-color: #6c30cc;
  //   }
  //   .el-tag.el-tag--info {
  //     color: #6c30cc;
  //   }
  //   .el-cascader__tags .el-tag {
  //     margin: 1px 0 1px 6px;
  //   }
  //   .el-tag--small {
  //     height: 30px;
  //   }
  //   .el-cascader__tags .el-tag .el-icon-close {
  //     background-color: #eae1f8;
  //     color: #6c30cc;
  //   }
  //   .el-tag .el-icon-close {
  //     font-size: 20px;
  //     height: 20px;
  //     width: 20px;
  //     line-height: 20px;
  //     top: 0px;
  //   }
  //   input {
  //     font-size: 18px;
  //   }
  //   .el-input__inner {
  //     min-height: 46px;
  //   }
  // }

  .el-cascader__search-input {
    margin: 3px 0 2px 12px;
    font-size: 14px;
  }
  .default-placeholder-value input::placeholder {
    color: #606266;
  }
}
#tabCohorts .el-table__header-wrapper {
  padding-top: 12px;
}
#tabCohorts .el-table .cell {
  line-height: 17px;
}
#tabCohorts .el-table th > .cell {
  font-weight: 700;
}
#tabCohorts .el-table td {
  padding: 9px 0px;
}
#tabCohorts span.el-checkbox__inner::after {
  border: 3px solid #fff;
  border-left: 0;
  border-top: 0;
  left: 6px;
  width: 6px;
  height: 13px;
}
#tabCohorts label.el-checkbox {
  line-height: 24px;
}
#tabCohorts .el-checkbox__input {
  zoom: 1 !important;
}
#tabCohorts .el-dialog {
  border-radius: 3px;
  width: 1200px;
  max-width: 95vw;
}
#tabCohorts .el-dialog__header {
  padding: 0px;
}
#tabCohorts .el-dialog__body {
  padding: 0px;
  height: auto;
  border-radius: 3px;
}
#tabCohorts .profileform .cohort-field .el-input__inner {
  height: 46px;
  font-size: 16px;
  font-weight: 400;
}
#tabCohorts .el-input.is-disabled.disable .el-input__inner {
  background-color: #e4e4e4;
  border-color: #e4e4e4;
}
#tabCohorts .profileform .team-parent-field .el-input__inner {
  height: 60px;
  background: #e4e4e4;
  border-left-width: 7px;
  border-left-style: solid;
  padding: 0 32px;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  opacity: 0.9;
}
#tabCohorts .profileform .team-parent-field input::placeholder {
  color: #000000;
  opacity: 0.9;
}
#tabCohorts .profileform .border-left-color- .el-input__inner {
  border-left-color: #747474;
}
#tabCohorts .profileform .border-left-color-6C30CC .el-input__inner {
  border-left-color: #6c30cc;
}
#tabCohorts .profileform .border-left-color-4F86C6 .el-input__inner {
  border-left-color: #4f86c6;
}
#tabCohorts .profileform .border-left-color-50B0C6 .el-input__inner {
  border-left-color: #50b0c6;
}
#tabCohorts .profileform .border-left-color-379392 .el-input__inner {
  border-left-color: #379392;
}
#tabCohorts .profileform .border-left-color-68D5B5 .el-input__inner {
  border-left-color: #68d5b5;
}
#tabCohorts .profileform .border-left-color-EE7885 .el-input__inner {
  border-left-color: #ee7885;
}
#tabCohorts .profileform .border-left-color-C99EC4 .el-input__inner {
  border-left-color: #c99ec4;
}
#tabCohorts .profileform .border-left-color-84B1ED .el-input__inner {
  border-left-color: #84b1ed;
}
#tabCohorts .profileform .border-left-color-31AADE .el-input__inner {
  border-left-color: #31aade;
}
#tabCohorts .profileform .border-left-color-F0DC05 .el-input__inner {
  border-left-color: #f0dc05;
}
#tabCohorts .profileform .border-left-color-E63A40 .el-input__inner {
  border-left-color: #e63a40;
}

/* Cosmetic polish: create/edit Cohort dialog (scoped to .ch-modal) */
.el-dialog.ch-modal {
  .el-input__inner,
  .el-textarea__inner {
    border: 1px solid #e2e4ea;
    border-radius: 10px;
    transition: border-color .15s ease, box-shadow .15s ease;
  }
  .el-input__inner:focus,
  .el-textarea__inner:focus {
    border-color: #6c30cc;
    box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.12);
  }
  .btnAddTeamModal,
  .btnAddTeamModal.el-button {
    background-color: #6c30cc !important;
    border-color: #6c30cc !important;
    color: #ffffff !important;
    border-radius: 10px;
    letter-spacing: 0.04em;
  }
  .btnAddTeamModal:hover,
  .btnAddTeamModal.el-button:hover {
    background-color: #5a25b0 !important;
    border-color: #5a25b0 !important;
    box-shadow: 0 6px 16px rgba(108, 48, 204, 0.18);
    opacity: 1;
  }
  /* Edit-mode Delete button: subtle danger, not a heavy gray slab */
  .btnCancelTeamModal[type="primary"],
  .btnCancelTeamModal.btn-gray {
    background-color: rgba(204, 48, 48, 0.08) !important;
    border: 1px solid rgba(204, 48, 48, 0.28) !important;
    color: #cc3030 !important;
    border-radius: 10px;
    letter-spacing: 0.04em;
  }
  .btnCancelTeamModal[type="primary"]:hover,
  .btnCancelTeamModal.btn-gray:hover {
    background-color: rgba(204, 48, 48, 0.14) !important;
    border-color: rgba(204, 48, 48, 0.42) !important;
    color: #b62a2a !important;
  }
  .btnCancelTeamModal[type="primary"].is-disabled,
  .btnCancelTeamModal.btn-gray.is-disabled,
  .btnCancelTeamModal[type="primary"][disabled],
  .btnCancelTeamModal.btn-gray[disabled] {
    background-color: #f4f5f8 !important;
    border-color: #e2e4ea !important;
    color: #b4b4b4 !important;
    cursor: not-allowed;
  }
  .el-switch.is-checked .el-switch__core {
    background-color: #6c30cc;
    border-color: #6c30cc;
  }
  .el-radio.is-checked .el-radio__label {
    color: #6c30cc;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background: #6c30cc;
    border-color: #6c30cc;
  }

  /* Segmented-style cohort_kind radio group */
  .cohort-type-radio {
    display: inline-flex;
    padding: 4px;
    background: #f6f7f9;
    border: 1px solid #e2e4ea;
    border-radius: 999px;

    .el-radio {
      margin: 0;
      padding: 6px 14px;
      border-radius: 999px;
      transition: background-color .15s ease, color .15s ease;

      .el-radio__input { display: none; }
      .el-radio__label {
        padding: 0;
        font-size: 13px;
        font-weight: 600;
        color: #6b7280;
      }

      &.is-checked {
        background: #ffffff;
        box-shadow: 0 1px 3px rgba(17, 24, 39, 0.08);
        .el-radio__label { color: #6c30cc; }
      }

      &:hover:not(.is-checked) .el-radio__label {
        color: #2f2f2f;
      }
    }
  }
}
</style>
